import Image from "next/image";
import styled from "styled-components";
import mailIcon from "../../public/images/afredfest/mail-icon.png";
import phoneIcon from "../../public/images/afredfest/phone-icon.png";

const Container = styled.div`
   /* background-color: #f8f8f8; */
   padding: 2rem 2rem 4rem 2rem;
`;

const ContainerInner = styled.div`
   display: flex;
   flex-direction: column-reverse;
   @media screen and (min-width: 768px) {
      flex-direction: row;
   }
`;

const BoxInfo = styled.div`
   flex-grow: 1;
   padding: 1rem 0;
   @media screen and (min-width: 768px) {
      flex-basis: 50%;
   }
`;
const BoxDesc = styled.div`
   padding: 1rem 0;
   flex-grow: 1;
   @media screen and (min-width: 768px) {
      flex-basis: 50%;
   }
`;
const OrganizerBox1 = styled.div`
   display: none;
   @media screen and (min-width: 768px) {
      display: block;
   }
`;
const OrganizerBox2 = styled.div`
   padding: 1rem 0;
   @media screen and (min-width: 768px) {
      display: none;
   }
`;

const Title = styled.h2`
   color: #8e44ad;
   margin-bottom: 1rem;
   letter-spacing: 0.25rem;
   font-weight: 700;
   font-size: 1.2rem;
   text-transform: uppercase;
`;

const OrganizerName = styled.h1`
   font-size: 2rem;
   margin-bottom: 1rem;
   font-family: "Millik";
`;
const ContactTitle = styled(OrganizerName)`
   @media screen and (min-width: 768px) {
      display: none;
   }
`;

const ContactInfo = styled.div`
   margin-bottom: 1rem;
`;

const ContactItem = styled.p`
   display: flex;
   align-items: center;
   margin-bottom: 0.5rem;
   > span {
      display: flex;
      flex-direction: column;
      margin: 0 1rem;
   }
   @media screen and (min-width: 768px) {
      > span {
         flex-direction: row;
      }
      > span > * {
         padding-right: 1rem;
      }
   }
`;

const Description = styled.p`
   line-height: 2;
   word-spacing: 0.25rem;
   font-size: 14px;
`;

const Link = styled.a`
   color: #3498db;
   text-decoration: none;
   &:hover {
      text-decoration: underline;
   }
`;

const Divider_SC = styled.div`
   margin: 2rem 0;
   height: 1px;
   width: 100%;
   /* padding: 0rem !important; */

   background-color: #e3e3e3;
`;

export const OrganizerInfoFooter = () => {
   return (
      <Container>
         <ContainerInner>
            <BoxInfo>
               <OrganizerBox1>
                  <Title>Organiser</Title>
                  <OrganizerName>Edusko Ltd</OrganizerName>
               </OrganizerBox1>

               <ContactInfo>
                  <ContactTitle>Contact Us</ContactTitle>
                  <ContactItem>
                     <Image src={phoneIcon} alt="phone icon" />
                     <span>
                        <span>+44 7776 634432</span>
                        <span> +234070 5270 4253</span>
                     </span>
                  </ContactItem>
                  {/* <ContactItem>
                     <Icon> </Icon> 
                  </ContactItem> */}
                  <ContactItem>
                     <Image src={mailIcon} alt="mail icon" />
                     <span>Info@Edusko.Com</span>
                  </ContactItem>
               </ContactInfo>
            </BoxInfo>
            <BoxDesc>
               <OrganizerBox2>
                  <Title>Organiser</Title>
                  <OrganizerName>Edusko Ltd</OrganizerName>
               </OrganizerBox2>
               <Description>
                  AFRED Fest UK 2024 is powered by Edusko Ltd UK. Our flagship platform,{" "}
                  <Link href="https://edusko.com" target="_blank" rel="noopener noreferrer">
                     edusko.com
                  </Link>{" "}
                  is Africa's largest education marketplace for schools, parents, students and
                  lenders. Currently working with over 8,000 top k-12 private schools in Nigeria,
                  Ghana & Kenya, we leverage data and tech to help parents access good k-12 schools
                  for their wards and for schools to enrol more students for less.
               </Description>
            </BoxDesc>
         </ContainerInner>

         <Divider_SC />
      </Container>
   );
};
